/*!
*
* Copyright (c) 2015, Peter Bengtsson
*
* Permission is hereby granted, free of charge, to any person obtaining a copy
* of this software and associated documentation files (the "Software"), to deal
* in the Software without restriction, including without limitation the rights
* to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
* copies of the Software, and to permit persons to whom the Software is
* furnished to do so, subject to the following conditions:
*
* The above copyright notice and this permission notice shall be included in
* all copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
* IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
* AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
* LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
* OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
* THE SOFTWARE.
*
*/

/*
 * How to use it
 * -------------
 *
 * Load this file and then call it like this:
 *
 *     Autocomplete(document.getElementById('searchthing'));
 *
 * More to come...
 */

/*
 * Brad's Deals additions
 * ----------------------
 * - Renamed autocompeter to autocompleter
 * - Added full tabbing and entering functionality
 * - Added hints and highlights for mid-word matches
 * - Consume new JSON response format:
 *   {
 *     "results": [
 *       {
 *         "id": 1234,
 *         "slug": "active-forever",
 *         "title": "Active Forever",
 *         "item_type": "merchant"
 *       },
 *       {
 *         "id": 210983,
 *         "slug": "coach-semi-annual-sale-free-shipping",
 *         "title": "Coach Semi Annual Sale + Free Shipping!",
 *         "item_type": "deal"
 *       }
 *     ]
 *   }
 * - JSON response item no longer is represented as an array.
 *   Previous JSON format:
 *   {
 *     "results": [
 *       [
 *         "stores/active-forever",
 *         "Active Forever",
 *         "store"
 *       ],
 *       [
 *         "stores/infantino",
 *         "Infantino",
 *         "store"
 *       ]
 *     ]
 *   }
 * - Item URL no longer is provided in API response
 * - Item URL is built dynamically based on the item_type
 * - Trim search term value of leading and trailing spaces.
*/

;(function (window, document) {
  'use strict';

  /* utility function to create DOM elements */
  function createDomElement(tag, options) {
    var e = document.createElement(tag);
    for (var key in options) {
      e[key] = options[key];
    }

    return e;
  }

  /* utility function to attach event handlers to elements */
  function attachHandler(target, type, handler) {
    if (target.addEventListener) {
      target.addEventListener(type, handler, false);
    } else {
      target.attachEvent(type, handler);
    }
  }

  function extend() {
    var key, object, objects, target, val, i, len, slice = [].slice;
    target = arguments[0];
    objects = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    for (i = 0, len = objects.length; i < len; i++) {
      object = objects[i];
      for (key in object) {
        val = object[key];
        target[key] = val;
      }
    }

    return target;
  }

  function setUp(q, options) {
    options = extend({
      ping: true,
    }, options || {});

    options.url += options.url.indexOf('?') > -1 ? '&' : '?';
    if (options.number) {
      options.url += 'n=' + options.number + '&';
    }

    options.url += '&q=';
    var results_ps = [];
    var selected_pointer = -1;
    q.spellcheck = false;
    q.autocomplete = 'off';

    // wrap the input
    var wrapper = createDomElement('span', { className: '_ac-wrap' });
    var hint = createDomElement('input', {
      tabindex: -1,
      spellcheck: false,
      autocomplete: 'off',
      readonly: 'readonly',
      type: q.type || 'text',
      className: q.className + ' _ac-hint'
    });

    // The hint is a clone of the original but the original has some
    // requirements of its own.
    q.classList.add('_ac-foreground');
    wrapper.appendChild(hint);
    var clone = q.cloneNode(true);
    wrapper.appendChild(clone);

    var r = createDomElement('div', { className: '_ac-results' });
    attachHandler(r, 'mouseover', mouseoverResults);
    wrapper.appendChild(r);

    q.parentElement.insertBefore(wrapper, q);
    q.parentNode.removeChild(q);
    q = clone;

    function escapeRegExp(str) {
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    }

    function highlightText(text) {
      var search_terms = terms.map(escapeRegExp);
      var re = new RegExp('\\b(\\w*(' + search_terms.join('|') + ')[\\S\']*)', 'gi');
      return text.replace(re, '<b>$1</b>');
    }

    function addItemTypeText(resultsText, itemType) {
      if (itemType === 'merchant') {
        itemType = 'store';
      }

      return resultsText + "<span class='search-item-type'>" + itemType + '</span>';
    }

    function removeItemTypeText(text) {
      return text.replace(/(store|merchant|deal|shopping guide)$/, '');
    }

    function mouseoverResults(e) {
      if (e.target.tagName === 'P') {
        if (selected_pointer !== +e.target.dataset.i) {
          selected_pointer = +e.target.dataset.i;
          displayResults();
        }
      }
    }

    function filterResults(results, terms) {
      // Return a new array where all results are matched
      // on all of the terms.
      var new_results = [];
      var search_terms = terms.map(escapeRegExp);
      var re = new RegExp('\\b(' + search_terms.join('|') + ')', 'gi');
      for (var i = 0, len = results.length; i < len; i++) {
        if (results[i]['title'] !== undefined && results[i]['title'].search(re) > -1) {
          new_results.push(results[i]['title']);
        }
      }

      return new_results;
    }

    var results = null;
    var preAjaxDisplayTimer = null;
    var terms;

    function displayResults(preAjax) {
      preAjax = preAjax || false;
      if (!preAjax && preAjaxDisplayTimer) {
        // This function has been called because we have new results.
        // If we had started a whilst-waiting-for-ajax filtering based
        // on what little we have, then we can now kill that effort.
        window.clearTimeout(preAjaxDisplayTimer);
      }

      var i, len;
      if (results === null) return;
      if (preAjax) {
        // filter the results with the new terms manually
        results = filterResults(results, terms);
      }

      if (results.length) {
        r.style.display = 'block';
        var ps = r.getElementsByTagName('p');
        for (i = ps.length - 1; i >= 0; i--) {
          ps[i].remove();
        }
      } else {
        r.style.display = 'none';
      }

      results_ps = [];
      var p, a;
      var hint_candidate = null;
      var hint_candidates = [];
      if (!results.length) {
        // If there are no results for the current query, we make
        // sure the is no hint underneath that you can tab-complete
        // because since there are no results, there's no point
        // tab completing.
        hint.value = '';
      }

      var search_terms = terms.map(escapeRegExp);
      var re = new RegExp('\\b(\\w*)(' + search_terms.join('|') + ')(\\w+)\\b', 'gi');

      // Because `r` is a DOM element that has already been inserted into
      // the DOM we collect all the `<p>` tags into a Document Fragment
      // and add the whole thing later into the `r` element.
      var p_fragments = document.createDocumentFragment();

      // Append link to regular search results page
      p = createDomElement('p');

      if (0 === selected_pointer) {
        p.classList.add('selected');
      }

      p.dataset.i = 0;
      a = createDomElement('a', {
        innerHTML: 'See All Search Results For "' + highlightText(q.value.trim()) + '"',
        href: '/search?query=' + encodeURIComponent(q.value.trim()) + "&ref=search_autocomplete"
      });
      p.appendChild(a);
      p_fragments.appendChild(p);
      results_ps.push(p);
      r.appendChild(p_fragments);

      for (i = 0, len = results.length; i < len; i++) {
        var found;
        var matched;

        while ((found = re.exec(results[i]['title'])) !== null) {
          matched = new RegExp('\\b' + escapeRegExp(found[0]) + '\\b', 'gi');

          hint_candidate = found[found.length - 1];
          if (hint_candidate !== undefined && !matched.test(q.value))  {

            if (selected_pointer === i + 1) {
              hint_candidates.push(hint_candidate);
            }
          }
        }

        if (results[i]['title'] !== undefined) {
          p = createDomElement('p');
          if (i + 1 === selected_pointer) {
            p.classList.add('selected');
          }

          p.dataset.i = i + 1;  // needed by the onmouseover event handler

          var resultsText = highlightText(results[i]['title']);
          var fullText = addItemTypeText(resultsText, results[i]['item_type']);
          var urlSearchAutocomplete = urlForItem(results[i]['slug'], results[i]['id'], results[i]['item_type'], results[i]['title'])

          a = createDomElement('a', {
            innerHTML: fullText,
            href: results[i]['item_type'] !== 'merchant' ? urlSearchAutocomplete + "?ref=search_autocomplete" : urlSearchAutocomplete + "&ref=search_autocomplete"
          });

          p.appendChild(a);
          p_fragments.appendChild(p);
          results_ps.push(p);
        }
      }

      r.appendChild(p_fragments);
      if (hint_candidates.length && q.value.charAt(q.value.length - 1) !== ' ') {
        hint_candidate = hint_candidates[selected_pointer % hint_candidates.length];
        hint.value = q.value + hint_candidate;
      } else {
        // If there are no candidates there's no point putting the
        // hint value to be anything.
        // Also, this solves the problem that if the q.value is so long
        // that it's typing exceeds the input box, the text alignment
        // (assuming the caret is on the right) becomes right aligned.
        hint.value = '';
      }
    }

    // Build item URL
    // This is a replacement of the original implementation where
    // URL was provided from the API
    function urlForItem(slug, id, type, title) {
      switch (type) {
        case 'deal':
          return '/deals/' + slug + '-p' + id;
        case 'merchant':
        case 'store':
          return '/search?query=' + encodeURIComponent(title.trim());
        case 'category':
          return '/categories/' + slug;
        case 'shopping guide':
          return '/guides/' + slug;
        default:
          return '/';
      }
    }

    function findParentForm(element) {
      var parent = element.parentNode;
      if (parent.nodeName === 'FORM') {
        return parent;
      }

      if (parent === null) {
        throw 'too deep. no parent form node to be found';
      }

      return findParentForm(parent);
    }

    var keyDownUpCount = -1;
    function handleKeyboardEvent(name) {
      var i, len;
      if (name === 'tab') {
        if (hint.value !== q.value && hint.value != '') {
          q.value = hint.value + ' ';
          handler();  // this starts a new ajax request
        } else if (hint.value === '' && results_ps.length) {
          var p = results_ps[selected_pointer];
          var a = p.getElementsByTagName('a')[1];
          q.value = hint.value = removeItemTypeText(a.textContent);
        }
      } else if (name === 'down' || name === 'up') {
        keyDownUpCount++;
        if (name === 'down') {
          selected_pointer = Math.min(results_ps.length - 1, ++selected_pointer);
        } else if (name === 'up') {
          selected_pointer = Math.max(0, --selected_pointer);
        }

        for (i = 0, len = results_ps.length; i < len; i++) {
          if (i === selected_pointer) {
            results_ps[i].classList.add('selected');
          } else {
            results_ps[i].classList.remove('selected');
          }
        }

        displayResults();
      } else if (name === 'enter') {
        var p = results_ps[selected_pointer];
        var a;

        // Only run this if a autocomplete element is highlighted
        if (p) a = p.getElementsByTagName('a')[0];

        if (keyDownUpCount > -1 || a && q.value === removeItemTypeText(a.textContent)) {
          r.style.display = 'none';
          window.location = a.href;
        } else {
          q.value = q.value.trim().replace(/\s+/g, ' ')

          findParentForm(q).submit();
          return true;
        }
      } else if (name === 'esc') {
        r.style.display = 'none';
      }

      return false;
    }

    function handleKeyEvent(e) {
      var relevant_keycodes = {
        13: 'enter',
        9: 'tab',
        38: 'up',
        40: 'down',
        27: 'esc'
      };
      if (!relevant_keycodes[e.keyCode]) return false;
      e.preventDefault();
      return handleKeyboardEvent(relevant_keycodes[e.keyCode]);
    }

    function handleAjaxError() {
      r.style.display = 'none';
    }

    var cache = {};
    var req;
    var req_value;

    function handler() {
      if (!q.value.trim()) {
        hint.value = '';
        r.style.display = 'none';
        return;
      } else if (hint.value.length) {
        // perhaps the hint.value no longer is applicable, in that case
        // unset the hint.value
        if (hint.value.indexOf(q.value.trim()) === -1) {
          hint.value = q.value;
        }

        if (r.style.display === 'block') {
          // display the results again because the displays are shown
          // but the typed value is not visible
          terms = q.value.trim().split(/\s+/);
          preAjaxDisplayTimer = window.setTimeout(function () {
            // now display results PRE-ajax
            displayResults(true);
          }, 150);

        }
      }
      // new character, let's reset the selected_pointer
      selected_pointer = -1;
      if (cache[q.value.trim()]) {
        var response = cache[q.value.trim()];
        terms = response.terms;
        results = response.results;
        displayResults();
      } else {
        if (req) {
          req.abort();
        }

        if (window.XMLHttpRequest) { // Mozilla, Safari, ...
          req = new window.XMLHttpRequest();
        } else if (window.ActiveXObject) { // IE 8 and older
          req = new window.ActiveXObject('Microsoft.XMLHTTP');
        } else {
          return;
        }

        req.onreadystatechange = function () {
          if (req.readyState === 4) {
            if (req.status === 200) {
              if (req_value === q.value) {
                var response = JSON.parse(req.responseText);
                cache[q.value.trim()] = response;
                terms = response.terms;
                results = response.results;
                displayResults();
              }
            } else {
              // if the req.status is 0, it's because the request was aborted
              if (req.status !== 0) {
                console.warn(req.status, req.responseText);
                handleAjaxError();
              }

            }
          }
        };

        req.open('GET', options.url + encodeURIComponent(q.value.trim()), true);
        req_value = q.value;
        req.send();
      }
    }

    function handleBlur(event) {
      hint.value = q.value;
      // Necessary so it becomes possible to click the links before they
      // disappear too quickly.
      setTimeout(function () {
        r.style.display = 'none';
      }, 200);

      event.preventDefault();
    }

    // Used to know the search widget has been focused once and only once.
    var firstFocus = true;

    function handleFocus() {
      if (firstFocus) {
        // The input field is focussed for the first time in this
        // session. That gives us an optimization opportunity to
        // warm up with a quick and simply little ping.
        if (options.ping && window.XMLHttpRequest) {
          // For the really web performance conscientious implementors,
          // you can make it send a ping by AJAX first. This will pre-emptively
          // do a DNS look up and cert checking so that that's taken care of
          // when you later do the actual AJAX.
          var ping = new window.XMLHttpRequest();
          ping.open('GET', options.url.split('?')[0] + '/ping');
          ping.send();
          firstFocus = false;
        }
      }

      if (q.value.length && results_ps.length) {
        r.style.display = 'block';
      }
    }

    attachHandler(q, 'input', handler);
    attachHandler(q, 'keydown', handleKeyEvent);
    attachHandler(q, 'blur', handleBlur);
    attachHandler(q, 'focus', handleFocus);

  }  // end of setUp

  window.Autocompleter = setUp;

})(window, document);
